import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { TranslateLoader } from '@ngx-translate/core';

/**
 * Custom translation loader that handles various response formats and errors
 * Supports both direct JSON and wrapped response formats
 */
@Injectable({
  providedIn: 'root'
})
export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`./assets/i18n/${lang}.json`, {
      responseType: 'text',
      headers: {
        'Accept': 'application/json, text/plain, */*'
      }
    }).pipe(
      timeout(5000), // 5 second timeout
      map((response: string) => {
        // First try to parse as direct JSON
        try {
          return JSON.parse(response);
        } catch (directParseError) {
          // If direct parsing fails, check if it's wrapped in {error: {}, text: "..."} format
          try {
            const wrappedResponse = JSON.parse(response);
            if (wrappedResponse && typeof wrappedResponse === 'object' && wrappedResponse.text) {
              // Parse the JSON content from the 'text' field
              return JSON.parse(wrappedResponse.text);
            }
          } catch (wrappedParseError) {
            console.error('Failed to parse translation content in all formats:', {
              directParseError,
              wrappedParseError,
              response: response.substring(0, 200) + '...' // First 200 chars for debugging
            });
            // Return empty object as fallback
            return {};
          }
        }

        // If we get here, direct parsing succeeded
        return JSON.parse(response);
      }),
      catchError((error) => {
        console.error('Error loading translation file:', error);
        console.warn('Returning empty translation object as fallback');
        // Return empty object as fallback
        return of({});
      })
    );
  }
}